/**
 * Устойчивый цвет по идентификатору.
 *
 * ── Зачем вынесено ──────────────────────────────────────────────────────────
 *
 * Той же логикой красятся аватары, метки аккаунтов и всё, что должно
 * узнаваться по цвету. Вторая копия палитры разошлась бы с первой, и один
 * аккаунт получил бы в списке чатов один цвет, а на аватаре другой — то есть
 * ровно то, ради чего цвет и вводится, перестало бы работать.
 *
 * Цвет выводится ДЕТЕРМИНИРОВАННО из идентификатора, а не выбирается случайно
 * и не хранится в базе: один и тот же аккаунт всегда одного цвета, между
 * перезагрузками и между сотрудниками.
 */

/**
 * Палитра. Восемь тонов из собственных цветов системы, приглушённых до одного
 * уровня насыщенности. Каждый проверен под белым текстом и проходит 4.5:1.
 */
export const SEED_COLORS = [
  "#145aff", // Royal Signal
  "#0f3b8c", // глубокий синий
  "#1667c9", // Cobalt, приглушённый
  "#0f6f77", // холодный бирюзовый
  "#0e811d", // Mint Win как заливка
  "#99642e", // Amber Pending как заливка
  "#b8493e", // Coral Lost как заливка
  "#374151", // Slate Caption
] as const;

/**
 * Индекс цвета по строке.
 *
 * djb2: короткий, устойчивый и без коллизий на близких идентификаторах —
 * два соседних uuid дают разные цвета, а не один и тот же.
 */
export function seedColorIndex(seed: string): number {
  let hash = 5381;
  for (let i = 0; i < seed.length; i += 1) {
    hash = ((hash << 5) + hash + seed.charCodeAt(i)) | 0;
  }
  return Math.abs(hash) % SEED_COLORS.length;
}

/** Готовый цвет по идентификатору. */
export function seedColor(seed: string): string {
  return SEED_COLORS[seedColorIndex(seed)] as string;
}
